import { actionTypes } from '../actions/modal.action';

const initialState = {
    open: false
}

// eslint-disable-next-line
export default (state = initialState, {type, payload}) => {
  switch (type) {

  case actionTypes.CHANGE_MODAL:
    return { ...state, ...payload };

  default:
    return state
  }
};
